import React, { Component } from "react";
import { connect } from "react-redux";
import { Spin } from "antd";
import { columns } from "./columns";
import { loadLocations } from "../../store/actions/locationAction";
import { loadQuittances } from "../../store/actions/quittanceAction";
import { loadReglements } from "../../store/actions/reglementAction";
import ListQuittance from "../../components/ListQuittance";

class Quittances extends Component {
  componentDidMount() {
    this.props.loadLocations();
    this.props.loadQuittances();
    this.props.loadReglements();
  }

  render() {
    const { locations, quittances, reglements } = this.props;

    return (
      <Spin
        spinning={!locations || !quittances || !reglements}
        size="large"
        tip="Chargement en cours..."
        wrapperClassName="view-spin"
      >
        <ListQuittance
          listData={
            quittances &&
            locations &&
            quittances
              .filter((quittance) => {
                const location = locations.find(
                  (location) => location.location_id === quittance.quittance_location_id
                );
                return location?.location_etat === "r";
              })
              .sort((a, b) => b.quittance_id - a.quittance_id)
          }
          locations={locations}
          reglements={reglements}
          tableOption={columns}
          addPanesRequete={this.props.addPanesRequete}
        />
      </Spin>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    loadLocations: () => dispatch(loadLocations()),
    loadQuittances: () => dispatch(loadQuittances()),
    loadReglements: () => dispatch(loadReglements()),
  };
};

// mapper le state aux props du component
const mapStateToProps = (state) => {
  return {
    utilisateur: state.utilisateur.data,
    locations: state.locations.data,
    quittances: state.quittances.data,
    reglements: state.reglements.data,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Quittances);
